<!--
* UI Name: Process Apply History
* Modify Date: 2021/08/13
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.processSetup.addProcess.applyHistory.header') }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <!-- [E]  Popup title-->

    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <!-- 203705_MapManager_Fix issues_9 -->
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col pt-0" lg="2">
              <span class="field-label required-text">
                {{ $t('lbl.processSetup.addProcess.applyHistory.workflowName') }}
              </span>
            </v-col>
            <v-col class="map-text-field inline-block-component pt-0 pl-0" lg="10">
              <v-text-field
                v-model="workflowName"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield scanner-textfield"
                heigth="30"
                outlined
                hide-details
                dense
                solo
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pb-0" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.processSetup.addProcess.applyHistory.comment') }}
              </span>
            </v-col>
            <v-col class="map-text-field inline-block-component pb-0 pl-0" lg="10">
              <v-text-field
                v-model="contentComment"
                class="data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield"
                heigth="30"
                ref="comRef"
                outlined
                hide-details
                dense
                solo
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="ml-0 mr-4">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-search" color="primary" @click="saveHistory()">
                {{ $t('btn.common.save') }}
              </v-btn>
              <v-btn class="btn btn-delete" @click="removeDialog">
                {{ $t('btn.common.cancel') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <dialogWindow
      ref="detailDialog"
      size="max"
      :detail="detailDialog"
      color="warning"
      @select-ok="onClickOkayAlert"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
  },
  name: 'edi-uploadfile-dialog',
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    versionList: Object,
    reFreshList: Function,
  },
  computed: {},
  data() {
    return {
      successDialog: false,
      detailDialog: '',
      contentComment: '',
      workflowName: '',
    };
  },
  mounted() {
    setTimeout(() => {
      this.$refs.comRef.focus();
    }, 300);
  },
  created() {
    this.workflowName = this.options.item.procNm;
  },
  methods: {
    saveHistory() {
      if (this.contentComment.trim() == '') {
        this.detailDialog = this.$t('msg.common.require', ['Comment']);
        this.$refs.detailDialog.dialog = true;
        return;
      }
      this.$emit('save-history', this.contentComment);
      this.removeDialog({});
    },
    onClickOkayAlert() {
      let self = this;
      setTimeout(() => {
        self.$refs.comRef.focus();
      }, 600);
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>

<style>
.add-map-layout-dialog {
  width: 888px !important;
}

.theme--dark .add-map-layout-dialog .dialog-body,
.theme--dark .add-map-layout-dialog .dialog-body .v-sheet {
  background-color: #292c35;
  border-left: none !important;
}

.add-map-layout-dialog
  .theme--dark
  .v-text-field.data-table-select-box.communication-select-box.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  background: #3b3e49;
}

.theme--dark .add-map-layout-dialog .v-text-field--outlined.flatfile-layout-selectbox fieldset,
.v-text-field--outlined.text-field-flatfile-layout fieldset {
  border-color: #3b3e49;
}

.add-map-layout-dialog .inline-block-component {
  display: flex;
}

.add-map-layout-dialog .csv-file-textfield,
.add-map-layout-dialog .flatfile-textfield {
  width: calc(100% - 70px);
  padding-right: 12px;
}
.add-map-layout-dialog .csv-file-textfield {
  width: 100%;
  padding-right: 12px;
}
.add-map-layout-dialog .map-name-textfield {
  padding-right: 2px;
}

.add-map-layout-dialog .btn-active {
  width: 70px;
  margin-top: -2px;
}

.add-map-layout-dialog .dialog-header {
  background-color: #253c51;
  height: 60px !important;
}
.map-text-field {
  padding-right: 0px;
}
/* .add-map-layout-dialog span {
    font-size: 14px;
    line-height: 19px;
    color: #12083F;
    font-weight: bold;
  } */

.add-map-layout-dialog .v-btn span {
  font-weight: normal;
}

.add-map-layout-dialog
  .theme--light.v-text-field--outlined.data-table-filter-text-field.text-field-flatfile-layout
  fieldset {
  /* border: 1px solid #CEDEFF; */
  border-radius: 3px;
}

.add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined fieldset {
  /* border: 1px solid #CEDEFF; */
  border-radius: 3px;
}

.theme--light .add-map-layout-dialog .v-text-field--outlined.readonly-textfield fieldset {
  background: #eeeeee;
}

.theme--dark .add-map-layout-dialog .v-text-field--outlined.readonly-textfield fieldset {
  background: #3b3e49;
}
/* 
  .theme--dark .add-map-layout-dialog .v-input input {
    color: #bbbbbb !important;
  } */

.theme--dark .add-map-layout-dialog .v-input.readonly-textfield input {
  color: #bbbbbb !important;
}

.add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined i {
  color: #cedeff;
}

.add-map-layout-dialog .v-text-field--outlined.flatfile-layout-selectbox fieldset,
.v-text-field--outlined.text-field-flatfile-layout fieldset {
  top: -8px;
}

/* .theme--dark .add-map-layout-dialog form {
    border: none;
    background-color: #292C35 !important;
  }

  .theme--dark .add-map-layout-dialog form span.field-label {
    color: #bbbbbb;
  } */

/* .add-map-layout-dialog .field-col {
    padding-right: 0px;
    padding-left: 20px;
    padding-top: 12px;
    line-height:30px;
  } */

/* .add-map-layout-dialog .required-col {
    padding-left: 0px;
  } */
/* .add-map-layout-dialog .not-required-col {
    padding-left: 21px;
  } */

.add-map-layout-dialog .button-col {
  padding-bottom: 10px;
}

.add-map-layout-dialog .v-text-field input,
.add-map-layout-dialog .v-text-field input::placeholder {
  font-size: 14px !important;
  font-weight: normal;
}
.data-table-select-box.custom-selectbox.map-name-selectbox .v-input__control {
  border-radius: 3px;
  border: 1px solid #cedeff;
  background: #ffffff;
}
.btn-form-control .status-rollback-button.map-dialog-btn,
.btn-form-control .delete-customer-edi-list-button.map-dialog-btn {
  width: 100px !important;
}
.add-map-layout-dialog .v-icon.notranslate.fas.fa-asterisk.theme--light {
  width: 17px;
}

.theme--dark
  .add-map-layout-dialog
  .data-table-select-box
  .v-input__control
  .v-input__slot
  .v-select__selections
  .v-select__selection,
.theme--dark
  .add-map-layout-dialog
  .data-table-select-box
  .v-input__control
  .v-input__slot
  .v-input__append-inner
  i {
  color: #bbbbbb !important;
  font-weight: normal;
}
/* .add-map-layout-dialog span.to-text{
  margin-right:10px;
  margin-left: 10px;
  line-height:30px;
} */
.add-map-layout-dialog .map-type-col {
  display: flex;
  padding-left: 2px;
}
.add-map-layout-dialog .flatfile-textfield.scanner-textfield {
  padding-right: 0px;
}
.scanner-load-btn {
  margin-left: 10px;
}
.theme--dark .map-text-field .edi-mes-list .v-input__control .v-input__slot {
  background-color: #3b3e49;
}
.theme--light .map-text-field .edi-mes-list .v-input__control .v-input__slot {
  border: 1px solid #cedeff;
  border-radius: 4px;
}
.theme--light .map-text-field .edi-mes-list .v-input__control .v-input__slot i {
  color: #cedeff;
}
/* .add-map-layout-dialog span.edi-version-text{
   position: absolute;
   left: 41px;
   line-height: 30px;
} */
/* .add-map-layout-dialog.custom-add-map-layout-dialog .v-input__control{
  display:block;
} */
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details {
  padding-left: 3px !important;
  margin-top: 4px;
}
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details .v-messages {
  font-size: 10px;
}
.add-map-layout-dialog.custom-add-map-layout-dialog .edi-version-col {
  padding-left: 26px !important;
}
.customer-add-map-layout {
  margin-top: -20px !important;
  margin-bottom: -18px !important;
}
</style>
